import { combineReducers } from 'redux';
import findIndex from 'lodash.findindex';
import find from 'lodash.find';
import {
  SOCIAL_MEDIA_SELECT,
  SOCIAL_MEDIA_MOVE_UP,
  SOCIAL_MEDIA_MOVE_DOWN,
  SOCIAL_MEDIA_REMOVE,
  SOCIAL_MEDIA_SAVE,
  SOCIAL_MEDIA_CHANGE_COLOR,
  SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
  SOCIAL_MEDIA_CHANGE_ICON_SIZE,
} from '../actions/action-names';

const selectedIcon = (state = '', action) => {
  switch(action.type) {
    case SOCIAL_MEDIA_SELECT:
      return action.icon;

    case SOCIAL_MEDIA_SAVE:
      if (action.icons && action.icons.length === 0 ||
          action.iconInfo.originalClassName === state) {
        return action.iconInfo.className;
      }

      return state;

    case SOCIAL_MEDIA_REMOVE:
      if (state !== action.icon) {
        return state;
      }

      const nextIcon = find(action.icons, i => i.className !== action.icon);

      if (nextIcon) {
        return nextIcon.className;
      }

      return state;

    default:
      return state;
  }
};

const color = (state = '#008800', action) => {
  switch(action.type) {
    case SOCIAL_MEDIA_CHANGE_COLOR:
      return action.color;

    default:
      return state;
  }
};

const hoverColor = (state = '#00ff00', action) => {
  switch(action.type) {
    case SOCIAL_MEDIA_CHANGE_HOVER_COLOR:
      return action.hoverColor;

    default:
      return state;
  }
};

const iconSize = (state = '32px', action) => {
  switch(action.type) {
    case SOCIAL_MEDIA_CHANGE_ICON_SIZE:
      return action.iconSize;

    default:
      return state;
  }
};

const sizes = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const icons = (state = [], action) => {
  const slIndex = findIndex(state, i => i.className === action.selectedIcon);

  switch(action.type) {
    case SOCIAL_MEDIA_REMOVE:
      return state.filter(i => i.className !== action.icon);

    case SOCIAL_MEDIA_MOVE_UP:
      return state.length === 0 || slIndex === 0 ? state : [
        ...state.slice(0, slIndex - 1),
        state[slIndex],
        state[slIndex - 1],
        ...state.slice(slIndex + 1)
      ];

    case SOCIAL_MEDIA_MOVE_DOWN:
      return state.length === 0 || slIndex === state.length - 1 ? state : [
        ...state.slice(0, slIndex),
        state[slIndex + 1],
        state[slIndex],
        ...state.slice(slIndex + 2)
      ];

    case SOCIAL_MEDIA_SAVE:
      const currentIcon = find(state, i => i.className === action.iconInfo.originalClassName);
      const icon = {
        className: action.iconInfo.className,
        url: action.iconInfo.url
      };

      if (currentIcon) {
        return state.map(i => i === currentIcon ? icon : i);
      }

      return [
        ...state,
        icon
      ];

    default:
      return state;
  }
};

export default combineReducers({
  selectedIcon,
  icons,
  color,
  hoverColor,
  iconSize,
  sizes,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/social-media-element-options-reducers.js